import { Component, inject, ViewChild } from '@angular/core';
import { ModalPartCategoryComponent } from 'src/app/components/inventory-modals/modal-part-category.component';
import { Part } from 'src/app/models/part';
import { InventoryService } from 'src/app/services/inventory.service';
import { STORAGE_KEYS } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-parts',
  template: `
    <div class="d-flex flex-column mb-4 mt-4">
      <div class="flex-column">
        <h1>Partes</h1>
      </div>
      <div class="flex-column">
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
        <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Partes</h4>
        <ul #subsidebar class="list-unstyled">
          <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts/categories" >Categorías</button></li>
          <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" (click)="openModalPartCategory()" >Parámetros</button></!-->
        </ul>
      </div>
      <div #pages class="flex-fill">
      <div class="d-flex mt-0">
        <div class="flex-fill">
          <div class="ms-2">
            <h3>Partes</h3>
          </div>
          <div class="list-group rounded-5 shadow mt-4" >
            <div class="list-group-item px-4 py-3 border-0">
              <div class="d-flex flex-fill mt-2">
                <div class="btn-group text-center w-100" role="group" aria-label="Filtro recibos">
                  
                </div>
              </div>
            </div>
            <div class="list-group-item w-100" >
              <table class="table table-sm" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz text-light py-2"># Parte <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-start bg-zazz text-light py-2">IPN </th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Revisión</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Unidades</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Descripción</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Categorías</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Ubicación</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Total inventario</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Rango de precio</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-part
                    [part]="part"
                    [profile]="profile" 
                    [permissions]="permissions"
                    routerLink="/inventory/parts/{{ part?.pk }}"
                    *ngFor="let part of parts | paginate: { itemsPerPage: query.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-part-category></app-modal-part-category>
  `,
  styleUrls: []
})
export class IndexPartsComponent {
  parts: Part[] = [];
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');
  permissions: any = {};

  currentView: string = 'parts';

  @ViewChild(ModalPartCategoryComponent, { static: true }) modalPartCategoryComponent !: ModalPartCategoryComponent;

  query: any = {
    details: true,
    location_detail: true,
    per_page: 25,
    page: 1
  };
  meta: any = {};

  p: number = 1;

  constructor(
    private invService: InventoryService,
    public icons: IconsService
  ) {
    this.loadParts();
  }

  loadParts() {
    this.invService.getParts(this.query).subscribe({
      next: (parts: any) => {
        console.log(parts);
        this.parts = parts.results;
      },
      error: (err: any) => {}
    });
  }

  openModalPartCategory(): void {
    console.log('createContract => ', this.modalPartCategoryComponent);
    const modalTemplate: any | undefined = this.modalPartCategoryComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalPartCategory']);
    }
  }

}
